import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { platformMeta } from '../platformMeta';
import { slotLabel } from '../slotLabel';
import { SocialPlatform } from '../types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Promote pillar; each part uses its own slice of it */
import styles from '../Promote.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ComposerChannelNoteProps {
  platform: SocialPlatform;
  /** ISO 8601. The hour this channel would go out at. */
  slot?: string;
}

/** What this platform rewards, and when its post lands. */
const ComposerChannelNoteComponent: React.FC<ComposerChannelNoteProps> = ({ platform, slot }) => {
  const intl = useIntl();

  return (
    <div className={styles.infoStrip}>
      <span>{intl.formatMessage(platformMeta[platform].note)}</span>
      {slot !== undefined ? (
        <span className={styles.infoStripSlot}>
          {intl.formatMessage(
            { id: 'app.sml.promote.composer.bestSlot', defaultMessage: 'Best slot is {slot}' },
            { slot: slotLabel(intl, slot) }
          )}
        </span>
      ) : null}
    </div>
  );
};

export const ComposerChannelNote = TypedMemo(ComposerChannelNoteComponent);
